/*
 *
 * --------------------------------------------------- */
jQuery(function ($) {
  $(".form-horizontal .wpcf7-file").each(function (index) {
    $(this)
      .parents("label")
      .after("<p class='filename'>選択されていません</p>");

    $(this).change(function () {
      var file = $(this)[0].files[0].name;
      $(this).parents("label").next(".filename").text(file);
    });
  });
});
